import { ICLDefApprover } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';
import { EntityService } from './EntityService';

export class CLDefApproverService extends EntityService<ICLDefApprover> {
    //protected childrenEntities = ['App03PortfolioUsers($expand=User)'];

    constructor() {
        super(`/CLDefApprovers`);
    }
}